import React from 'react'
import { Icon, ItemCard, ItemCardContent, ItemCardFooter, ItemCardHeader } from '../../../components';

interface OfficialAccountItemProps {
  logoPic: string,
  title: string,
  todayNews: number,
  todayNewUsers: number,
  allUsers: number,
  siteId: string
}

const clsPrefix = 'cn-of-accs-list';

const OfficialAccountItem: React.FC<OfficialAccountItemProps> = (
  {
    logoPic = '',
    title = 'sunnysunny sunny的小店',
    todayNews = 0,
    todayNewUsers = 0,
    allUsers = 0,
    siteId
  }
) => {

  function handleUpgrade() {
    window.location.href = "https://www.kuaizhan.com/v3/homepage/pricing";
  }

  function handleEnterBackend() {
    window.location.href = `https://www.kuaizhan.com/weixin/stat?site_id=${siteId}`
  }
  return (
    <ItemCard style={{ marginBottom: '20px' }}>
      <ItemCardHeader 
        logoPic={logoPic}
        title={title}
      />
      <ItemCardContent className={`${clsPrefix}__item--content`}>
        <div>今日消息：{todayNews}</div>
        <div>今日用户新增数：{todayNewUsers}</div>
        <div>总用户数：{allUsers}</div>
      </ItemCardContent>
      <ItemCardFooter className={`${clsPrefix}__item--opt`}>
        <div 
          style={{marginBottom: '13px', paddingRight: '8px'}}
          onClick={() => handleUpgrade()} 
        >
          <Icon 
            name="upgrade" 
            style={{
              marginRight: '8px',
              fontSize: '24px',
            }}
          />
          <span>升级权益</span>
        </div>
        <div  
          onClick={() => handleEnterBackend()} 
        >
          <Icon 
            name="manag"
            style={{
              marginRight: '8px',
              fontSize: '20px',
            }}
          />
          <span>进入后台管理</span>
        </div>
      </ItemCardFooter>
    </ItemCard>
  )
}

export default OfficialAccountItem;